export default __webpack_public_path__ + "static/media/our-services-edu-special-education-01.745299b8.jpg";